import { fetchProducts } from '~/js/utilities/products-and-collections';
import { getProductBadges } from '~/js/utilities/product';

const heroProduct = (id, variantsSkus, medias) => ({
  id,
  variantsSkus,
  loading: true,
  printsLoading: true,
  shopifyData: null,
  parentSelectedVariants: [],
  medias,
  error: '',
  // afterpayPlacement: null,

  init() {
    window.heroProduct = this;

    this.fetchProduct();
  },

  get ready() {
    return Boolean(!this.loading && !this.printsLoading && this.shopifyData);
  },

  get badges() {
    return this.shopifyData ? getProductBadges(this.shopifyData) : [];
  },

  fetchProduct() {
    fetchProducts([id])
      .then((products) => {
        this.loading = false;
        this.shopifyData = products[id];
      })
      .catch((e) => {
        this.error = e.message;
      });
  },
});

export default heroProduct;
